/*eslint-disable */
import { useCallback, useMemo } from "react";

import { EMPTY_TEMPLATE_SELECTOR } from "../../../../constants";

const useMenuActions = ({
    clickedElement,
    currentTemplate,
    onUpdateTemplateSelector,
    getPathTo
}) => {
    const templateSelectors = useMemo(
        () => currentTemplate?.template_selectors || [],
        [ currentTemplate?.template_selectors ]
    );

    const handleTextAnyElement = useCallback(
        () => {
            const newTemplateSelector = {
                ...EMPTY_TEMPLATE_SELECTOR,
                type_code: "NONE",
                selector: clickedElement.target.innerText
            };

            const newList = [ ...templateSelectors, newTemplateSelector ];
            onUpdateTemplateSelector(newList);
        },
        [ clickedElement?.target?.innerText, onUpdateTemplateSelector, templateSelectors ]
    );

    const handleElementWithText = useCallback(
        () => {
            const xPath = getPathTo(clickedElement.target);

            const newTemplateSelector = {
                ...EMPTY_TEMPLATE_SELECTOR,
                type_code: "XPATH",
                selector: xPath
            };

            const newList = [ ...templateSelectors, newTemplateSelector ];
            onUpdateTemplateSelector(newList);
        },
        [ clickedElement, getPathTo, onUpdateTemplateSelector, templateSelectors ]
    );

    return useMemo(
        () => ({
            onElementWithText: handleElementWithText,
            onTextAnyElement: handleTextAnyElement
        }),
        [ handleElementWithText, handleTextAnyElement ]
    );
};

export default useMenuActions;
